/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.websitegrader.rpc.WebsiteGraderRpcService
 */

export const getGradeRpc = {
  serviceName: 'com.hubspot.websitegrader.rpc.WebsiteGraderRpcService',
  rpcName: 'getGrade',
  auth: 'external',
  fingerprint: '95e5y5Jd0NQh_LsabT0-MiVIuRtSIcHV',
  na1Only: true,
  isStreaming: false,
  isHublessAppAuth: false
};
export const enqueueGradeRpc = {
  serviceName: 'com.hubspot.websitegrader.rpc.WebsiteGraderRpcService',
  rpcName: 'enqueueGrade',
  auth: 'external',
  fingerprint: 'UbBeB1C1fl-tJv32wreBoSVIuRtSIcHV',
  na1Only: true,
  isStreaming: false,
  isHublessAppAuth: false
};
export const enqueuePreviewRpc = {
  serviceName: 'com.hubspot.websitegrader.rpc.WebsiteGraderRpcService',
  rpcName: 'enqueuePreview',
  auth: 'external',
  fingerprint: 'y8OvqojPNrCrgufHdATMtiVIuRtSIcHV',
  na1Only: true,
  isStreaming: false,
  isHublessAppAuth: false
};
export const submitFormRpc = {
  serviceName: 'com.hubspot.websitegrader.rpc.WebsiteGraderRpcService',
  rpcName: 'submitForm',
  auth: 'external',
  fingerprint: 'E740KlCuHzMLCIGdTBzPdSVIuRtSIcHV',
  na1Only: true,
  isStreaming: false,
  isHublessAppAuth: false
};